import {ImageCarousel} from "../common/ImageCarousel";
import {useProductDetails} from "../../store/productDetails";
import {useEffect} from "@wordpress/element";

const GallerySkeleton = () => (
    <div className="p-4 animate-pulse">
        <div className="bg-base-300 rounded-2xl w-full aspect-square mb-4"/>
        <div className="flex gap-2 justify-center">
            {Array.from({length: 4}).map((_, i) => (
                <div key={i} className="w-14 h-14 bg-base-300 rounded-lg shrink-0"/>
            ))}
        </div>
    </div>
);

export const ProductGallery = () => {
    const {product, loading} = useProductDetails();
    const hasImages = Array.isArray(product?.images) && product.images.length > 0;

    useEffect(() => {
        if (hasImages) {
            const fallback = document.querySelector('.product-gallery-static');
            if (fallback) fallback.style.display = 'none';
        }
    }, [hasImages]);

    if (loading) return <GallerySkeleton/>;

    return <>
        {hasImages && (
            <div className="p-4">
                <ImageCarousel images={product?.images}/>
            </div>
        )}
    </>;
};